export const contracts = {
  multicall: {
    address: "0x3CD8AD561cc3C40aF80A6c6d10e13482063aC0b9",
  },
  liquidityMiningManager: {
    address: "0x383A1C067A377665c9bEfF16a236B6b8FFB6EFA9",
  },
  escrowedReward: {
    address: "0xF4cC7b898F96632A4b50b8917617a633b0f85f71",
  },
  view: {
    address: "0xb19e239Db03aB1CB45894a5ED586BC2BBDDeA9C6",
  },
  singleTokenPool: {
    address: "0x162ba8F3a02C321Cf0aa360d2C5B5dd523D7F35E",
  },
  lpPool: {
    address: "0x29De9Dfa4ADFE50C878fb2FffF8C1b28d9e24355",
  },
  uniswapLpPairAddress : {
    address: "0xD8E7d368ab9BDF0010A9934B0e801B3F38CECEF6"
  },
  copperLaunchPoolContract:{
    address: "0xeEDcA0C2cBa983b718C66094fC8E41F9eD52F82a"
  },
  balancerVault: {
    address: "0xba12222222228d8ba445958a75a0704d566bf2c8",
    poolId: "0xeedca0c2cba983b718c66094fc8e41f9ed52f82a00020000000000000000011c"
  }
};
